import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import './index.css'
import ZendeskLink from 'components/Common/ZendeskLink'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import PasswordBox from './password'
import { SignIn, resendOTP } from 'store/actions/authActions'
import { useDispatch, useSelector } from 'react-redux'
import Alert from '@mui/material/Alert'
import Button from 'components/Common/Button'
import { Typography } from '@mui/material'
import { PRIMARY_BUTTON } from 'themes/theme'
import { getOperatingSystem } from 'utils/helper'
import iconAppStore from 'assets/mobile/app_store.png'
import iconPlayStore from 'assets/mobile/play_store.png'
import { useContext } from 'react'
import { AuthStateContext } from 'context/auth'

const PasswordVerify = () => {
  const navigate = useNavigate()
  const [inValid, setInvalid] = useState(false)
  const [password, setPassword] = useState()
  const [spinner, setSpinner] = useState(false)
  const [showError, setShowError] = useState('')
  const dispatch = useDispatch()
  const emailInfo = useSelector(state => state.authReducer)
  const [authState, authDispatch] = useContext(AuthStateContext)
  const [width, setWindowWidth] = useState()
  const updateDimentions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
  }
  window.addEventListener('resize', updateDimentions)

  useEffect(() => {
    updateDimentions()

    window.addEventListener('resize', updateDimentions)
    return () => window.removeEventListener('resize', updateDimentions)
  }, [])

  const responsive = {
    showTopNavMenu: width > 1023,
  }

  const isMac = getOperatingSystem(window)?.toLowerCase()?.includes('mac')

  const handleSubmit = e => {
    setShowError(false)
    e.preventDefault()
    if (emailInfo.emailData.emailVerified) {
      if (!password) return
      SignIn(
        {
          email: emailInfo.email.toLowerCase(),
          password,
        },
        onComplete,
        dispatch,
        navigate,
      )
    } else {
      resendOTP(emailInfo.email.toLowerCase(), () => {})
      dispatch({
        type: 'EMAILDETAIL',
        payload: { ...emailInfo.emailData, password },
      })
      navigate('/auth/verify-otp')
    }
    // navigate('/auth/resend-mail')
  }

  const handleSubmitMob = e => {
    setShowError(false)
    e.preventDefault()
    authDispatch({ type: 'signIntoSignUpMob', payload: { email: authState.email, password: password } })
    if (emailInfo.emailData.emailVerified) {
      if (!password) return
      SignIn(
        {
          email: emailInfo.email,
          password,
        },
        onComplete,
        dispatch,
        navigate,
      )
    } else {
      resendOTP(emailInfo.email, () => {})
      dispatch({
        type: 'EMAILDETAIL',
        payload: { ...emailInfo.emailData, password },
      })
      //   navigate('/auth/verify-otp')
      navigate('/auth/mobile/verify-otp')
    }
  }

  const onComplete = (val, showError) => {
    setSpinner(val)
    setShowError(showError)
  }

  const handleBlur = e => {
    const { value } = e.target
    if (!value) {
      setInvalid('This Field is required')
    } else {
      setInvalid(false)
    }
  }

  const handleClose = () => {
    setShowError('')
  }

  return (
    <>
      <Box
        padding="30px"
        height="100%"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        display="flex"
        color="#25245f"
        showTopNavMenu={responsive.showTopNavMenu}
        style={{ display: width > 1023 ? 'flex' : 'none' }}
      >
        <Typography variant="h4" sx={{ marginTop: '26%' }} className="authTitle text-center">
          Good to see you again!
        </Typography>
        <Box onSubmit={handleSubmit} width="330px" className="mt-5" component="form">
          <Box className={`${inValid ? 'my-3 authForm inValid' : 'my-3 authForm'}`}>
            <PasswordBox
              onChange={e => setPassword(e.target.value)}
              autoFocus
              onBlur={handleBlur}
              label="Password"
              name="password"
            />
            <Box className="errorMessage mt-1" fontSize="12px" fontWeight={400} color="#D14343">
              {inValid}
            </Box>
          </Box>
          {showError && (
            <Alert role="alert" severity="error" className="mt-2" onClose={handleClose}>
              {showError}
            </Alert>
          )}
          <Box className="mt-5" textAlign="center">
            <Button type={PRIMARY_BUTTON} loading={spinner} sx={{ width: '250px' }} submit>
              Sign In
            </Button>
            <Box marginY="10px">
              <Link className="authLink" to={'/auth/forgot-password'}>
                Forgot password
              </Link>
            </Box>
          </Box>
        </Box>
        <Box marginTop="auto">
          <Box paddingX="60px" paddingY="30px" color="#66668F" textAlign="center" fontSize="12px" lineHeight="18px">
            By creating an account, I acknowledge I have read, understand, and agree to the Markaaz’s&nbsp;
            <a rel="noreferrer" className="authLink" href="https://markaaz.com/terms-and-conditions" target="_blank">
              Terms and Conditions
            </a>
            , including the arbitration, limitation of liability, and class waiver provisions. I also confirm I have
            read and understand the Markaaz &nbsp;
            <a rel="noreferrer" className="authLink" href="https://markaaz.com/privacy/" target="_blank">
              Privacy Policy
            </a>
            .
          </Box>
          <ZendeskLink />
        </Box>
      </Box>

      <Box style={{ display: width <= 1024 ? 'flex' : 'none' }}>
        <Box
          padding="30px"
          height="100%"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          display="flex"
          color="#25245f"
          marginTop="46px"
        >
          <Typography variant="h6" textAlign="center" margin="40px 0px">
            Good to see you again!
          </Typography>
          <Box width="330px" className="mt-3" component="form" marginBottom="50px">
            <Box className={`my-3 authForm ${inValid ? 'inValid' : ''}`}>
              <PasswordBox
                onChange={e => setPassword(e.target.value)}
                autoFocus
                onBlur={handleBlur}
                // label="Password"
                placeholder="Password"
                name="password"
              />
              <Box className="errorMessage mt-1" fontSize="12px" fontWeight={400} color="#D14343">
                {inValid}
              </Box>
            </Box>
            <Box textAlign="center">
              <Button
                type={PRIMARY_BUTTON}
                sx={{ width: '250px', height: '50px', marginTop: '40px' }}
                loading={spinner}
                onClick={handleSubmitMob}
                submit
              >
                Sign In
              </Button>
            </Box>
          </Box>
          <Typography variant="caption" textAlign="center" color="#66668F">
            Already have an account?
            <br />
            Please go to your desktop or app to sign in.
          </Typography>
          <Box marginTop="40px">
            <img
              style={{ cursor: 'pointer' }}
              src={isMac ? iconAppStore : iconPlayStore}
              width={150}
              alt="mobilestore"
              onClick={() => {
                if (isMac) {
                  window.open('https://apps.apple.com/us/app/markaaz/id1632920268', '_self')
                } else {
                  window.open('https://play.google.com/store/apps/details?id=com.markaaz.dashboard&hl=en&gl=US')
                }
              }}
            />
          </Box>
          <Box marginTop="40px" textAlign="center">
            <Typography variant="caption" color="#66668F">
              By creating an account, I acknowledge I have read, understand, and agree to the Markaaz’s&nbsp;
              <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/terms-and-conditions" target="_blank">
                Terms and Conditions
              </a>
              , including the arbitration, limitation of liability, and class waiver provisions. I also confirm I have
              read and understand the Markaaz &nbsp;
              <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/privacy/" target="_blank">
                Privacy Policy
              </a>
              .
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default PasswordVerify
